import { render, staticRenderFns } from "./RatingScale.vue?vue&type=template&id=13c4b2d6"
import script from "./RatingScale.vue?vue&type=script&lang=js"
export * from "./RatingScale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports